import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { FlagsAuth } from '../enums/feature-flags.enum';

@Injectable({
  providedIn: 'root',
})
export class AdminGuard {
  public flagsAuth: any = FlagsAuth;
  public isLoggedIn: boolean = false;

  constructor(
    private readonly router: Router,
    private readonly authService: AuthService
  ) {}

  public canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    this.isLoggedIn = !!this.authService.getToken();
    const userRoles: string[] = this.authService.getUserRoles();

    if (this.isLoggedIn && userRoles.includes(this.flagsAuth.ADMIN)) {
      return true;
    } else if (this.isLoggedIn && !userRoles.includes(this.flagsAuth.ADMIN)) {
      this.router.navigateByUrl('/main/home');
      return false;
    }

    this.router.navigateByUrl('/auth/ingreso');
    return false;
  }
}
